export const SOCIAL_CONNECTIONS_PATH = '/profile/social-connections';

export const isSocialConnectionState = (
  state: string | null | undefined,
): state is string => state?.startsWith('connect.') ?? false;
